<dialog-draggable-header>Span Maintenance</dialog-draggable-header>

<div #content mat-dialog-content>
   <div class="table-holder">
      <data-table [data]="spans" [columns]="columns" [filterColumnDisplay]="false" (edit)="updateSpan($event)"
         (select)="updateSelectedSpan($event)" [pageSize]="pageOptions.size" [paging]="true" [lazy]="true"
         (lazyLoad)="onLazyLoad($event)" [loading]="loading" [totalRecords]="total">
         <ng-container actionStart>
            <button mat-button (click)="onAddSpanClick()">Add Span</button>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <button mat-button (click)="removeHandler()">Delete Span</button>
         </ng-container>
         <ng-container actionEnd>
            <button mat-button (click)="close()" (keydown.enter)="close()">Close</button>
         </ng-container>
      </data-table>
   </div>
</div>